import React from 'react';
import { observer } from 'mobx-react';
import { AsyncDataPlaceholder } from '../../../../ui';
import { AccountDetailsSubmit } from './AccountDetailsSubmit';
import { useAccountDetailsSubmit } from './hooks/useAccountDetailsSubmit';
import { PersonalDetails } from '../../../shared/account/details/ui/sections';
import { EmailWithSuggestion } from '../../../shared/account/details/ui/fields/EmailWithSuggestion';
import { useCreateEmailSuggestionStore } from '../../../shared/account/domain/stores/useCreateEmailSuggestionStore';
import { useDetailsFormContext } from '../../../shared/account/details/hooks/useDetailsFormContext';
import { IDetailsFormData } from '../../../shared/account/details/types/IDetailsFormData';
import { SaveDetailsError } from '../../../parking/ui/booking-steps/details/sections/SaveDetailsError';
import { UseFormReturn } from 'react-hook-form';

interface IAccountDeatilsForm {
	form: UseFormReturn<IDetailsFormData>;
}
export const AccountDetailsForm = observer(({ form }: IAccountDeatilsForm) => {
	const { error, submit } = useAccountDetailsSubmit();
	const {
		formState: { isSubmitting },
	} = useDetailsFormContext();
	const emailSuggestionStore = useCreateEmailSuggestionStore();

	return (
		<form onSubmit={form.handleSubmit(submit)}>
			<PersonalDetails
				emailField={<EmailWithSuggestion store={emailSuggestionStore} />}
			/>
			{isSubmitting && <AsyncDataPlaceholder />}
			{error && <SaveDetailsError error={error} />}
			<AccountDetailsSubmit />
		</form>
	);
});
